import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@user/store/authorization/userSlice'
import { externalProductPestPacName } from '@sales-center/common'

export const useGetLocationDocUrl = (locationId: string) => {
  const { externalProduct, clientUrl } = useSelector(selectCurrentUser)

  switch (externalProduct) {
    case externalProductPestPacName:
      return `${clientUrl}/letters/default.asp?LocationID=${locationId}`
    default:
      return ''
  }
}
